<template>
  <div>
    <div class="head">
      <p v-if="!question">暂无数据</p>
      <div class="list">
        <p class="tophead">{{question.description}}</p>
        <div class="list_box" v-for="(item,index) in list" :key="index">
          <p>{{item.description}}</p>
          <!-- 单选 -->
          <div v-if="item.subjectType==1">
            <a-radio-group v-model="value[item.id]">
              <a-radio
                v-for="(child,childrenIndex) in item.questionItemResp"
                :key="childrenIndex"
                :style="radioStyle"
                :value="child.id"
                @change="onRadioChange(item.id,child.id)"
              >{{child.text}}</a-radio>
            </a-radio-group>
          </div>
          <!-- 多选 -->
          <div v-if="item.subjectType==2">
            <a-checkbox-group
              v-model="value[item.id]"
              name="checkboxgroup"
              :options="checkbox(item.questionItemResp)"
              @change="onCheckChange(item.id)"
            />
          </div>
          <!-- 填空 -->
          <div v-if="item.subjectType==3">
            <a-textarea
              v-model="value[item.id]"
              @change="onAreaChange(item.id)"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </div>
        </div>
      </div>
      <div class="btn">
        <a-button type="primary" size="large" @click="submit">提交问卷调查</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { vote, saveVoteSubmit, saveVoteItem } from "@/api/user-center";
import { ls } from "@/utils/tool";
export default {
  data() {
    return {
      question: {},
      list: [],
      value: {},
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      form: {},
      id: this.$route.query.id,
    };
  },
  async created() {
    // console.log(this.$route.query.id);
    let res = await vote(this.$route.query.id);
    // console.log(res.data.questionResps);
    if (res.code !== 200) {
      this.$message.warning(res.message);
      this.list = [];
      this.question = {};
      return;
    }
    this.question = res.data;
    this.list = res.data.questionResps;
  },
  methods: {
    // 单选
    onRadioChange(id, childid) {
      this.form[id] = childid;
    },
    // 多选
    onCheckChange(id) {
      if (this.value[id].length == 0) {
        this.form[id] = null;
      } else {
        this.form[id] = this.value[id].toString();
      }
    },
    checkbox(item) {
      let arr = [];
      item.forEach((e) => {
        arr.push({ label: e.text, value: e.id });
      });
      return arr;
    },
    //填空
    onAreaChange(id) {
      if (this.value[id] !== "") {
        this.form[id] = this.value[id];
      } else {
        this.form[id] = null;
      }
    },
    // 提交
    async submit() {
      let { form, list } = this;
      let data = 0;
      list.forEach((item) => {
        if (form[item.id] == undefined || form[item.id] == null) {
          data = 1;
        }
      });
      if (data !== 0) {
        this.$message.warning("还有未填写的内容，请填写后提交！");
        return;
      }
      let obj = {
        voteId: this.id,
        memberId: ls.get("sysUser").id,
      };
      let res = await saveVoteSubmit(obj);
      console.log("问卷调查第一步", res);
      let newobj = {};
      if (res.code == 200) {
        newobj.submitId = res.data.id;
        newobj.itemId = this.id;
        newobj.form = this.form;
        const step2 = await saveVoteItem(newobj);
        if (step2.code == 200) {
          this.$message.success('提交成功')
          this.$router.push('/user-center/question')
        }else{
           this.$message.error(res.message)
        }
      }
    },
  },
  computed: {},
};
</script>

<style lang='less' scoped>
.head {
  .tophead {
    text-align: center;
    font-size: 28px;
    font-weight: 800;
  }
  .list {
    .list_box {
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
      margin-bottom: 30px;
      p {
        margin: 0;
        margin-bottom: 5px;
        font-size: 16px;
      }
      div {
        display: flex;
      }
    }
  }
  .btn {
    padding: 20px 0;
    text-align: center;
  }
}
</style>